import { z } from 'zod';
import { FinanceSettingsSchema } from '@/shared/models/ContextDataModel/interfaces/entities/finance-settings.ts';
import { BusinessCaseSchema, POSITION_STATUS_SCHEMA } from '@schuettflix/interfaces';
import { GetPositionConfigurationResponseSchema } from './get-position-configuration.ts';
import { ProductConfigurationSchema } from '@/shared/models/ContextDataModel/interfaces/entities/product-configuration.ts';
import { CustomerInfoSchema } from '@/shared/models/ContextDataModel/interfaces/entities/customer-info.ts';

export const PatchProductConfigurationSchema = ProductConfigurationSchema.extend({
    id: z.string().uuid().optional(),
});

export const PatchPositionConfigurationRequestSchema = z.object({
    validFrom: z.coerce.date().optional(),
    validTo: z.coerce.date().optional(),
    businessCase: BusinessCaseSchema.optional(),
    active: z.boolean().optional(),
    note: z.string().optional(),
    platformOrganizationId: z.number().positive().optional(),
    financeSettings: z.array(FinanceSettingsSchema).optional(),
    productConfigurations: z.array(PatchProductConfigurationSchema).optional(),
    status: POSITION_STATUS_SCHEMA.optional(),
    customer: CustomerInfoSchema.pick({ manualCostCenter: true }).optional(),
});

export const PatchPositionConfigurationResponseSchema = GetPositionConfigurationResponseSchema;

export type PatchProductConfiguration = z.infer<typeof PatchProductConfigurationSchema>;

export type PatchPositionConfigurationRequest = z.infer<typeof PatchPositionConfigurationRequestSchema> & {
    productConfigurations?: PatchProductConfiguration[];
};

export type PatchPositionConfigurationResponse = z.infer<typeof PatchPositionConfigurationResponseSchema>;
